export const STAGES = [
  { id: 0,  label: 'In talks',          color: '#A78BFA', bg: '#F3EFFE' },
  { id: 1,  label: 'Deal agreed',        color: '#60A5FA', bg: '#EFF6FF' },
  { id: 2,  label: 'Product pending',    color: '#F59E0B', bg: '#FFFBEB' },
  { id: 3,  label: 'Product received',   color: '#F59E0B', bg: '#FFFBEB' },
  { id: 4,  label: 'Shooting',           color: '#EC4899', bg: '#FDF2F8' },
  { id: 5,  label: 'Editing',            color: '#CB97F9', bg: '#FAF0FF' },
  { id: 6,  label: 'Pending approval',   color: '#F97316', bg: '#FFF7ED' },
  { id: 7,  label: 'Approved',           color: '#60A5FA', bg: '#EFF6FF' },
  { id: 8,  label: 'Delivered',          color: '#34D399', bg: '#ECFDF5' },
  { id: 9,  label: 'Live',               color: '#10B981', bg: '#D1FAE5' },
  { id: 10, label: 'Paid / Done',        color: '#059669', bg: '#A7F3D0' },
];

export const COLLAB_TYPES = [
  { id: 'paid',       label: 'Paid',          color: '#059669', bg: '#D1FAE5' },
  { id: 'barter',     label: 'Barter',        color: '#7C3AED', bg: '#EDE9FE' },
  { id: 'paidbarter', label: 'Paid + Barter', color: '#D97706', bg: '#FEF3C7' },
  { id: 'ugc',        label: 'UGC Only',      color: '#DB2777', bg: '#FCE7F3' },
];

export const PRIORITIES = [
  { id: 'urgent', label: 'Urgent', color: '#DC2626', bg: '#FEE2E2' },
  { id: 'high',   label: 'High',   color: '#D97706', bg: '#FEF3C7' },
  { id: 'normal', label: 'Normal', color: '#7C3AED', bg: '#EDE9FE' },
  { id: 'low',    label: 'Low',    color: '#9CA3AF', bg: '#F3F4F6' },
];

export const CATEGORIES = [
  'Skincare','Beauty','Food & Drink','Fashion','Travel',
  'Lifestyle','Tech','Fitness','Home & Decor','Wellness','Other',
];

export const DELIVERY_STATUS = [
  { id: 'na',         label: 'Not applicable' },
  { id: 'pending',    label: 'Pending dispatch' },
  { id: 'dispatched', label: 'Dispatched' },
  { id: 'received',   label: 'Received' },
];

export const SHOOT_LOCATIONS = [
  { id: 'home',  label: 'Home shoot' },
  { id: 'brand', label: 'Visit brand/venue' },
  { id: 'both',  label: 'Both' },
];

export const DEFAULT_RATE_ITEMS = [
  { id: 'reel',      label: 'Instagram Reel',  amount: '' },
  { id: 'story',     label: 'Instagram Story', amount: '' },
  { id: 'static',    label: 'Static Post',     amount: '' },
  { id: 'ugc_reel',  label: 'UGC Reel',        amount: '' },
  { id: 'ugc_photo', label: 'UGC Photo',       amount: '' },
  { id: 'tiktok',    label: 'TikTok Video',    amount: '' },
];

export const LINK_CATEGORIES = [
  { id: 'skincare',   label: '✨ Skincare',   color: '#f9a8d4', bg: 'rgba(249,168,212,.15)', border: 'rgba(249,168,212,.25)' },
  { id: 'supplement', label: '💊 Supplement', color: '#34d399', bg: 'rgba(52,211,153,.12)',  border: 'rgba(52,211,153,.2)'  },
  { id: 'nail',       label: '💅 Nails',      color: '#f472b6', bg: 'rgba(244,114,182,.12)', border: 'rgba(244,114,182,.25)' },
  { id: 'fashion',    label: '👗 Fashion',    color: '#CB97F9', bg: 'rgba(203,151,249,.15)', border: 'rgba(203,151,249,.25)' },
  { id: 'food',       label: '🍽️ Food',       color: '#fbbf24', bg: 'rgba(251,191,36,.12)',  border: 'rgba(251,191,36,.2)'  },
  { id: 'wellness',   label: '🧘 Wellness',   color: '#93c5fd', bg: 'rgba(147,197,253,.12)', border: 'rgba(147,197,253,.2)'  },
  { id: 'fitness',    label: '💪 Fitness',    color: '#fb923c', bg: 'rgba(251,146,60,.12)',  border: 'rgba(251,146,60,.2)'  },
  { id: 'other',      label: '✦ Other',       color: '#e2e8f0', bg: 'rgba(226,232,240,.1)',  border: 'rgba(226,232,240,.2)'  },
];

export const DELIVERABLE_TIPS = {
  'Skincare': [
    'Show the texture and application — close-up of applying to skin works well',
    'Include a before/after or morning/night routine context',
    'Voiceover tip: mention key ingredient + one personal result you noticed',
    'Avoid heavy filters — skincare needs to look authentic',
    'Film in natural light near a window for best skin visibility',
  ],
  'Beauty': [
    'Transformation angle works great — start without product, end with it',
    'GRWM format performs strongly',
    'Voiceover tip: describe the finish — matte, dewy, long-lasting etc',
    'Include the product name in first 3 seconds for brand recall',
    'Show swatches if it is a colour product',
  ],
  'Food & Drink': [
    'The first 2 seconds must show the food looking its absolute best',
    'ASMR-style sounds get strong engagement',
    'Voiceover tip: describe taste first, then where to get it',
    'Natural light or warm indoor lighting — avoid cold white light',
  ],
  'Fashion': [
    'Multiple outfit transitions work extremely well in Reels',
    'Show movement — walk, spin, sit — fabric needs to move on camera',
    'Voiceover tip: mention fit, size worn, and one styling tip',
    'Film against a clean or aesthetically consistent background',
  ],
  'Travel': [
    'Hook in first 2 seconds — most visually stunning shot first',
    'Voiceover tip: one surprising fact about the place builds curiosity',
    'Keep clips to 2-3 seconds each — fast pacing works for travel',
    'Include practical info (cost, best time to go) for save-worthy content',
  ],
  'Lifestyle': [
    'Day-in-the-life format integrates product naturally',
    'Voiceover tip: share a personal story or problem the product solved',
    'Aesthetic consistency matters — match your usual feed vibe',
    'Relatability over perfection — candid moments outperform staged ones',
  ],
  'Fitness': [
    'Show the product in action during an actual workout',
    'Voiceover tip: mention one specific performance benefit you noticed',
    'Upbeat music with synced cuts to the beat increases watch time',
  ],
  'Tech': [
    'Lead with the most impressive feature in first 3 seconds',
    'Voiceover tip: one problem it solves > list of features',
    'Show real use case — not just unboxing',
  ],
  'Home & Decor': [
    'Before/after room transformation gets massive saves',
    'Voiceover tip: mention the vibe/aesthetic you were going for',
    'Good ambient lighting is non-negotiable for home content',
  ],
  'Wellness': [
    'Morning routine or ritual context integrates product naturally',
    'Voiceover tip: share how it makes you feel, not just what it does',
    'Authenticity is key — wellness audiences are highly sceptical of overselling',
  ],
  'Other': [
    'Hook in first 2 seconds is critical regardless of category',
    'Voiceover tip: lead with a problem your audience has, then introduce the solution',
    'Show the product being used, not just held',
    'Keep main message to one clear point per video',
  ],
};
